import { EntityStatus } from '@/api';
import { Entity } from '@/models';
import { sortBy } from 'lodash';

import Vue from 'vue';

export function sortFuelTanks(tanks: any[]) {
	return tanks.sort(
		(a, b) => (getStatusPriority(a.status) > getStatusPriority(b.status) && 1) || -1,
	);
}

function getStatusPriority(status: string): number {
	switch (status) {
		case 'live':
			return 1;
		case 'pending':
			return 2;
		case 'install':
			return 3;
		case 'sign-off':
			return 4;
		case 'removed':
			return 5;
		case 'cancelled':
			return 6;
		default:
			return 0;
	}
}

export const formatAuditFieldChanges = (fieldsString: string): string => {
	const values = fieldsString.split(',');
	if (values.length === 0) {
		return 'Previously empty';
	}
	return values
		.map((value: string) => {
			if (!value) {
				return 'Empty';
			}
			return Vue.filter('titleCase')(value);
		})
		.join(', ');
};

export const sortEntitiesByStatus = <T extends Entity>(entities: T[]) => {
	return sortBy(entities, [
		function(entity: T) {
			return [
				EntityStatus.Live,
				EntityStatus.SignOff,
				EntityStatus.Install,
				EntityStatus.Pending,
				EntityStatus.Removed,
				EntityStatus.Cancelled,
				'No status',
			].indexOf(entity.status ?? 'No status');
		},
	]);
};
